import React, { useState } from "react";
import { PageHeader } from "./PageHeader";
import { DataBox } from "./DataBox";
import { SalePrint } from "./SalePrint"
import { useSaleSoModel } from "../saleSoModel";
import { SettleScaniaPrints } from "./settleScaniaPrints"
import { WhConfirmModal } from "./details/WhConfirmModal";

export default () => {
    const {
        print,
        settleScaniaPrint
    } = useSaleSoModel();
    return (
        <>
            <PageHeader />
            <DataBox />
            {print && <SalePrint />}
            {settleScaniaPrint && <SettleScaniaPrints />}
            <WhConfirmModal />
        </>
    )
}